export const selectLoginAutomatedPageContainer = (state) => state.containers.loginAutomatedPageReducer;

// Need to use .get, beucase reducer defaulState was created by using ImmutableJS
export const selectInitialDataConfig = (state) => selectLoginAutomatedPageContainer(state).get('initialDataConfig');



// WEBPACK FOOTER //
// ./src/containers/LoginAutomatedPage/selectors.js